import { svg } from 'lit';

export const circleInfoFilledIcon = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
<circle cx="12" cy="12" r="10" fill="#6b6c6f"/>
<circle cx="12" cy="7.5" r="1.5" fill="#ffffff"/>
<rect x="10.5" y="10.5" width="3" height="7.5" rx="1.5" fill="#ffffff"/>
</svg>`;
